module.exports = __webpack_public_path__ + "static/img/single_item_image3.b3f6099.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/programme/single_item_image3.png
// module id = jTgY
// module chunks = 1